import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'inputId',
		'inputDestroy',
		'inputDisableDestroyCheckbox',
	]

	static values = { destroyListId: String }

	connect() {
	}

	markToDestroy() {
		if (!this.hasInputIdTarget || (this.hasInputIdTarget && !this.inputIdTarget.value)) {
			this.element.remove()
		} else if(this.hasInputDisableDestroyCheckboxTarget) {
			for (const checkbox of this.inputDisableDestroyCheckboxTargets) { checkbox.checked = false }
			this.hideElement()
		} else if(this.hasInputDestroyTarget) {
			this.inputDestroyTarget.value = '1'
			this.hideElement()
			this.moveToDestroyList()
		} else {
			console.error('Missing input target(s) to destroy in NestedAttributeDestroyableController.')
		}

		this.dispatch('markToDestroy')
	}

	hideElement() {
		this.element.classList.add('d-none')
		this.element.classList.add('mark-to-destroy')
		this.element.classList.remove('list-group-item')
	}

	moveToDestroyList() {
		if (this.hasDestroyListIdValue)  {
			const destroyListElement = document.getElementById(this.destroyListIdValue)
			this.element.parentNode.removeChild(this.element)
			destroyListElement.append(this.element)
		}
	}
}
